/* @flow */

import keymirror from 'keymirror';

const SharedConstants = keymirror({
  SHARED_PURGE: null
});

export { SharedConstants };
